export type CurrentBlock = {
	// Headings and labels
	Header?: string;
	SubHeader?: string;
	FiltersLabel: string;
	ResetFiltersLabel: string;
	FiltersHeader: string;
	ApplyFiltersLabel: string;
	PdfIconAlternateText: string;
	SearchForOppositeVersionFilesLinkLabel: string;

	// Search UI
	SearchPlaceHolderText: string;
	SearchResultPageSize: number;

	// Table column labels
	ColumnCode: string;
	ColumnShortCodesCode: string;
	ColumnLanguageCode: string;
	ColumnSoldIn: string;
	ColumnDetails: string;
	ColumnArchived: string;

	// No results HTML
	NoResultXhtmlString: string;
};

export type BaseViewModel = {
	WebDocumentType: string;
	SearchForOppositeVersionFilesUrl?: string;
	Language: string;
	CurrentPageId: number;
};

export type ViewModel = {
	CurrentBlock: CurrentBlock;
	BaseViewModel: BaseViewModel;
};

// Result rows
export type DocumentRow = {
	code: string;
	ifuResourceLink: string;
	catalogNumbers: string;
	language: string;
	soldIn: string;
	details: string;
	archived?: string | null;
	webDocumentType?: string;
};

// Facets
export type FacetItem = {
	count: number;
	checked: boolean;
	name: string | number;
	groupId?: string;
	value: string | number;
	visible: boolean;
};

export type FacetGroupName = 'Regions' | 'AvailableInCountries';

export type FacetGroupModel = {
	id: string | number;
	name: FacetGroupName;
	data: FacetItem[];
};

export const FACET_KEYS = ['Regions', 'AvailableInCountries'] as const;
export type FacetKey = typeof FACET_KEYS[number];

export type FacetChangePayload = { group: FacetGroupModel };

// API contracts
export type DocumentSearchRequest = {
	WebDocumentType: string;
	Terms: string[];
	PageSize: number;
	FacetGroups: FacetGroupModel[];
	SearchForArchivedFiles: boolean;
	Language: string;
	CurrentPageId: number;
};

export type DocumentSearchResponse = {
	webDocumentType: string;
	terms: string[];
	facetGroups: FacetGroupModel[];
	pageSize: number;
	currentPage: number;
	searchResultItems: DocumentRow[];
	hits: number;
	noSearchResult: boolean;
};
